import React from 'react'
import { CCol, CFormLabel, CFormInput, CRow } from '@coreui/react-pro'
import InfoTooltip from './InfoTooltip'

const CaptainMultipliers = () => (
  <CRow className="g-3">
    <CCol md={4}>
      <CFormLabel className="fw-bold d-flex align-items-center">
        Captain (C)
        <InfoTooltip content="Points scored by the Captain are multiplied by this fixed rate." />
      </CFormLabel>
      <CFormInput value="2x Points" readOnly disabled />
    </CCol>
    <CCol md={4}>
      <CFormLabel className="fw-bold d-flex align-items-center">
        Vice-Captain (VC)
        <InfoTooltip content="Points scored by the Vice-Captain are multiplied by this fixed rate." />
      </CFormLabel>
      <CFormInput value="1.5x Points" readOnly disabled />
    </CCol>
    <CCol md={4}>
      <CFormLabel className="fw-bold d-flex align-items-center">
        Triple Captain (TC)
        <InfoTooltip content="When a member uses their Triple Captain chip, their Captain's points are multiplied by this fixed rate instead." />
      </CFormLabel>
      <CFormInput value="3x Points" readOnly disabled />
    </CCol>
    <CCol xs={12}>
      <small className="text-medium-emphasis">
        These multipliers are fixed for every game and cannot be changed.
      </small>
    </CCol>
  </CRow>
)

export default CaptainMultipliers
